import request from './index'

// 文件上传接口封装
export function uploadFile(data) {
	return request({
		url: '/resource/app/oss/upload',
		method: 'post',
		data,
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		cancelLoading: true
	})
}